import { ProxyTypeName } from '@fd/common/biz/proxyType';
import Icon from './Icon';

type ProxyIconType = {
  type: ProxyTypeName;
} & React.SVGProps<SVGSVGElement>;

export default function ProxyIcon({ type, ...props }: ProxyIconType) {
  const icons = {
    residential: <Icon.ResidentialProxy {...props} />,
    mobile: <Icon.MobileProxy {...props} />,
    datacenter: <Icon.DatacenterProxy {...props} />,
    isp: <Icon.ISPProxy {...props} />,
  };
  return icons[type];
}
